import { Draggable } from "@hello-pangea/dnd";
import { Checkbox, FormControlLabel, styled } from "@mui/material";
import { IListItem } from "../../interface/list-item";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";

interface IListOptions extends IWithClassName {
    parentId?: string;
    data: Array<IListItem>;
    onHighlight: (isChecked: boolean, item: IListItem) => void;
    isSingleColumn?: boolean;
    disabled?: boolean;
}

const ListOptions = ({
    data,
    parentId,
    onHighlight,
    disabled,
    className,
}: IListOptions) => (
    <ul className={className}>
        {data.map(({ id, name }, index) => (
            <Draggable
                key={id}
                draggableId={id}
                index={index}
                isDragDisabled={disabled}
            >
                {(provided) => (
                    <li
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        value={id}
                        data-parent-value={parentId}
                        className="child-item"
                    >
                        <FormControlLabel
                            control={
                                <Checkbox
                                    onChange={(event) =>
                                        onHighlight(
                                            event.currentTarget.checked,
                                            { id, name },
                                        )
                                    }
                                    disabled={disabled}
                                />
                            }
                            label={name}
                        />
                    </li>
                )}
            </Draggable>
        ))}
    </ul>
);

export default styled(ListOptions)(
    ({ theme, isSingleColumn }: IWithThemeProps & IListOptions) => ({
        display: "grid",
        gridTemplateColumns: isSingleColumn ? "100%" : "repeat(2, 50%)",
        justifyContent: "center",
        padding: 0,
        listStyle: "none",
        margin: 0,
        cursor: "pointer",
        ".MuiFormControlLabel-root": {
            padding: theme?.spacing(0, 1),
            margin: theme?.spacing(0.15, 0),
            width: "90%",
        },
        ".MuiFormControlLabel-root:has(.Mui-checked)": {
            backgroundColor: theme?.palette.search.iconColor,
            color: theme?.palette.otherFeatures.textColor,
            borderRadius: 5,
        },
        ".MuiCheckbox-root": {
            display: "none",
        },
        ".MuiTypography-root": {
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
        },
    }),
);
